/*
 * Copyright Red Hat, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  DatabaseService,
  resolvePackagePath,
} from '@backstage/backend-plugin-api';

import { Knex } from 'knex';

const migrationsDir = resolvePackagePath(
  '@red-hat-developer-hub/backstage-plugin-bulk-import-backend',
  'migrations',
);

export async function migrate(databaseManager: DatabaseService): Promise<Knex> {
  const knex = await databaseManager.getClient();

  if (!databaseManager.migrations?.skip) {
    await knex.migrate.latest({
      directory: migrationsDir,
    });
  }
  return knex;
}
